/**
 * Public routes derived from the frozen Content Studio bundle.
 *
 * PAWTENANT-CONTENT-STUDIO-INTEGRATION-001
 *
 * src/router/config.tsx spreads these next to the "/blog/:slug" entry:
 *   * CMS_CREATED_ROUTES  — one static route per created page (a static
 *     segment outranks "/blog/:slug" in React Router's ranking, exactly like
 *     the hand-registered standalone articles above it).
 *   * CMS_REDIRECTS       — `from` → `to` pairs rendered as <Navigate replace>.
 *     A direct request for `from` never reaches the SPA: middleware.ts answers
 *     a permanent 308 straight to `to` (src/generated/cmsRedirects.ts,
 *     PAWTENANT-CONTENT-STUDIO-SERVER-REDIRECTS-001). The <Navigate> only
 *     covers in-app navigation to an old address (no network request).
 *
 * Only paths under a known public prefix are honoured here; scripts/cms/fetch.mjs
 * already refuses a created page or redirect that collides with a compiled
 * route, so a route in this list can never shadow an existing page.
 */

import { cmsCreatedPages, cmsRedirects } from "./bundle";

/** Template prefixes: "blog" articles and "guide" pages (scripts/cms/inventory.mjs). */
export const CMS_PUBLIC_PREFIXES = ["/blog/", "/guides/"] as const;

function isPublicCmsPath(path: string): boolean {
  return CMS_PUBLIC_PREFIXES.some((p) => path.startsWith(p) && path.length > p.length && !path.slice(p.length).includes("/"));
}

export const CMS_CREATED_ROUTES: string[] = cmsCreatedPages()
  .map((c) => c.path)
  .filter(isPublicCmsPath);

export const CMS_REDIRECTS: Array<{ from: string; to: string }> = cmsRedirects().filter(
  (r) => isPublicCmsPath(r.from) && r.from !== r.to && !CMS_CREATED_ROUTES.includes(r.from),
);
